export class Question {
  id: string;
  question: string;
  selected: boolean;
}
